import { render, staticRenderFns } from "./comp_ReviewCard.vue?vue&type=template&id=35911f36&scoped=true&"
import script from "./comp_ReviewCard.vue?vue&type=script&lang=js&"
export * from "./comp_ReviewCard.vue?vue&type=script&lang=js&"
import style0 from "./comp_ReviewCard.vue?vue&type=style&index=0&id=35911f36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35911f36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VRating } from 'vuetify/lib/components/VRating';
installComponents(component, {VCard,VRating})
